import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { Trans } from 'react-i18next';

import { useVehicleForm } from '../VehicleOverlay/VehicleForm/hooks/useVehicleForm';
import { useInventories } from '../../OrderStatus/hooks/useInventories';

import { VehicleInformation } from './VehicleInformation';
import { VehicleSpecifications } from './VehicleSpecifications';
import { OrderInformation } from './OrderInformation';
import { VehicleStatusCard } from './VehicleStatusCard';

import Button from '../../../../Common/DesignSystem/Button';
import { P2 } from '../../../../Common/DesignSystem/Text';

const VehicleDetailsModal = ({ history, match, settings, userSession, location }) => {
  const [vehicle_oem_details, setVehicleOemDetails] = useState(null);
  const [vehicle_options, setVehicleOptions] = useState(null);

  const [isEditing, setIsEditing] = useState(false);
  const [isConvertingToVehicle, setIsConvertingToVehicle] = useState(false);

  const {
    vehicleForm,
    setVehicleForm,
    updateVehicleForm,
    updateSelect,
    formDetails,
    vehicleOemDetails,
    setStarValue,
    submitNew: createVehicle,
    loadDivisions,
    loadVMHs,
  } = useVehicleForm(settings, match, history, false, vehicle_oem_details, vehicle_options, false);

  const {
    createInventory,
    updateInventory,
    isLoadingInventoryMutation,
    inventoryForm,
    updateInventoryForm,
    uploadImage,
    loadingImage,
    imageThumbnail,
    imageName,
    uploadSpecSheet,
    loadingSpec,
    specName,
    convertInventoryToVehicle,
  } = useInventories({ userSession, history, match, setVehicleForm, loadDivisions, loadVMHs, location });

  useEffect(() => {
    if (match.url.includes('order/edit')) {
      setIsEditing(true);
    }

    if (match.url.includes('order/convert')) {
      setIsConvertingToVehicle(true);
    }
  }, []);

  useEffect(() => {
    if (settings) {
      setVehicleOptions(settings.vehicle_options);
      setVehicleOemDetails(settings.vehicle_details);
    }
  }, [settings]);

  const closeModal = () => {
    window.history.back();
  }

  const handleCreateInventory = async () => {
    const createdInventory = await createInventory(vehicleForm, inventoryForm);
  }

  const handleUpdateInventory = async () => {
    const updatedInventory = await updateInventory(vehicleForm, inventoryForm);
  }

  const handleConvertInventoryToVehicle = async () => {
    createVehicle(true, convertInventoryToVehicle(vehicleForm, inventoryForm));
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', maxHeight: '90vh', backgroundColor: '#F4F6F8', borderRadius: '16px' }}>
      <div style={{ backgroundColor: 'white', display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
        <div className="overlay_header_close" onClick={closeModal} >
          &times;
        </div>
      </div>

      <div style={{ backgroundColor: 'white', display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between', padding: '0 24px 32px', gap: '24px' }}>
        <div style={{ flex: 2 }}>
          <VehicleInformation {...{ vehicleForm, inventoryForm, updateVehicleForm, updateSelect, imageThumbnail, imageName, uploadImage, loadingImage, isConvertingToVehicle }} />
        </div>
        <div style={{ flex: 1 }}>
          <VehicleStatusCard {...{ vehicleForm, updateSelect, formDetails, setStarValue, isConvertingToVehicle }} />
        </div>
      </div>

      <div style={{ overflowY: 'auto', flex: 1 }}>
        <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white', margin: '24px', padding: '24px', gap: '16px', borderRadius: '16px', boxShadow: '0px 4px 16px 0px rgba(51, 51, 51, 0.08), 0px 4px 4px 0px rgba(51, 51, 51, 0.04)' }}>
          <div style={{ display: 'flex', flexDirection: 'column', padding: '24px', gap: '16px', borderRadius: '16px', border: '1px solid #DFE3E8' }}>
            <VehicleSpecifications {...{ vehicleForm, inventoryForm, updateVehicleForm, updateSelect, vehicleOemDetails, specName, uploadSpecSheet, loadingSpec, isConvertingToVehicle }} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', padding: '24px', gap: '16px', borderRadius: '16px', border: '1px solid #DFE3E8' }}>
            <OrderInformation {...{ inventoryForm, updateInventoryForm, isConvertingToVehicle }} />
          </div>
        </div>
      </div>

      <div className="overlay-bottom-buttons">
        <div className="overlay-bottom-buttons--text">
          {isConvertingToVehicle ? (
            <P2>Complete the <span>highlighted fields</span> <br /> to convert this Order to Inventory</P2>
          ) : (
            <P2><span>Highlighted fields</span> are required <br /> to create a new order</P2>
          )}
        </div>

				<Button secondary large leading_ic={isConvertingToVehicle ? "Order" : null} label={isConvertingToVehicle ? "Revert to Order" : "Cancel"} onClick={closeModal} />

        {isConvertingToVehicle ? (
				  <Button primary large leading_ic="Vehicle" label="Convert to Inventory" disabled={isLoadingInventoryMutation} onClick={handleConvertInventoryToVehicle} />
        ) : (
				  <Button primary large label={isEditing ? "Save Changes" : "Create New"} disabled={isLoadingInventoryMutation} onClick={isEditing ? handleUpdateInventory : handleCreateInventory} />
        )}
			</div>
    </div>
  )
}

const mapStateToProps = store => ({
  userSession: store.userSession,
  data: store.data,
  settings: store.settings,
  stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(VehicleDetailsModal)